import { Search } from '@mui/icons-material'
import { styled, TextField } from '@mui/material'
import theme from 'lib/theme'

export const SearchField = styled(TextField, {
  shouldForwardProp: (props) => props !== 'hover' && props !== 'width',
})<{ hover: boolean; width?: string }>(({ hover, width }) => ({
  width: width ?? '358px',
  marginRight: theme.spacing(4),
  transition: '0.5s',
  '& .MuiOutlinedInput-root': {
    paddingRight: 0,
    height: '38px',
    borderColor: 'transparent',
    backgroundColor: hover
      ? theme.palette.action.hover
      : theme.palette.secondary.main,
    fontWeight: 'bold',
    '&.Mui-focused fieldset': {
      border: `1px solid ${theme.palette.primary.main}`,
    },
  },
  '& .MuiOutlinedInput-notchedOutline': {
    borderWidth: 0,
  },
  '& .MuiOutlinedInput-input': {
    '&:hover': { color: theme.palette.text.primary },
  },
  '& .MuiFormHelperText-root': {
    color: theme.palette.primary.main,
  },
  [theme.breakpoints.between('xs', 'sm')]: {
    marginTop: theme.spacing(1),
    width: '70vw',
  },
  input: {
    color: theme.palette.text.primary,
    '&::placeholder': {
      color: theme.palette.text.secondary,
      fontWeight: 'bold',
      opacity: 1,
      transition: '0.5s',
    },
  },
}))

export const SearchIcon = styled(Search, {
  shouldForwardProp: (props) => props !== 'hover',
})<{ hover: boolean }>(({ hover }) => ({
  fill: hover ? theme.palette.text.primary : theme.palette.text.secondary,
  transition: '0.5s',
}))

export const BlueSearchIcon = styled(Search, {
  shouldForwardProp: (props) => props !== 'query',
})<{ query: string }>(({ query }) => ({
  backgroundColor:
    query.length < 3
      ? theme.palette.action.disabled
      : theme.palette.primary.main,
  fill: theme.palette.commonColors.white,
  width: '52px',
  height: '38px',
  borderRadius: '0 4px 4px 0',
  padding: '6px',
  '&:hover': {
    cursor: query.length < 3 ? 'auto' : 'pointer',
    background: 'transparent',
    backgroundColor:
      query.length < 3
        ? theme.palette.action.disabled
        : theme.palette.primary.main,
    fill: theme.palette.commonColors.white,
  },
}))
